'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListGetMoreFundsButton = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListGetMoreFundsButton, _Component);

  function IyvListGetMoreFundsButton(props) {
    (0, _classCallCheck3.default)(this, IyvListGetMoreFundsButton);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListGetMoreFundsButton.__proto__ || (0, _getPrototypeOf2.default)(IyvListGetMoreFundsButton)).call(this, props));
  }

  (0, _createClass3.default)(IyvListGetMoreFundsButton, [{
    key: 'render',
    value: function render() {
      var hasMore = this.props.lastResult && this.props.lastResult.length >= _config2.default.queryMaxFunds;

      // has results but no funds
      if (this.props.lastResult && this.props.funds.length === 0) {
        return _react2.default.createElement(
          'div',
          { styleName: 'reset-search-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'reset-search-info' },
            'Sorry, no funds found.'
          ),
          _react2.default.createElement(
            'button',
            {
              onClick: this.props.removeFilters,
              styleName: 'reset-search',
              role: 'button',
              tabIndex: '0',
              title: 'Reset search filters'
            },
            'Reset search filters',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-undo' })
          )
        );
      }

      // has results but there are more funds
      return _react2.default.createElement(
        'div',
        { styleName: 'more-funds-wrapper' },
        _react2.default.createElement(_reactLoader2.default, {
          options: { scale: 0.70, top: '20%' },
          loaded: !this.props.loading
        }),
        _react2.default.createElement(
          'div',
          null,
          /* if more funds, show a more funds button, else disable it */
          hasMore ? _react2.default.createElement(
            'button',
            {
              onClick: this.props.clickGetMoreFunds,
              styleName: 'more-funds',
              role: 'button',
              tabIndex: '0'
            },
            'Get more funds',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-plus-circle' })
          ) : _react2.default.createElement(
            'div',
            { styleName: 'no-more-funds' },
            'No more funds',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-minus-circle' })
          ),
          /* if there's no more funds, show a message */
          !hasMore ? _react2.default.createElement(
            'div',
            { styleName: 'no-more-funds-info' },
            'Looking for your favorite fund and can\'t find it? Sorry, but we don\'t have everything in our database.'
          ) : null
        )
      );
    }
  }]);
  return IyvListGetMoreFundsButton;
}(_react.Component), _class2.propTypes = {
  lastResult: _react.PropTypes.array,
  funds: _react.PropTypes.array,
  removeFilters: _react.PropTypes.func,
  loading: _react.PropTypes.bool,
  clickGetMoreFunds: _react.PropTypes.func
}, _temp)) || _class);
exports.default = IyvListGetMoreFundsButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListGetMoreFundsButton.js
// module id = 1327
// module chunks = 0